import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'creditcard-payment-success',
    templateUrl: './creditcard-payment-success.component.html'
  })
export class CreditCardPaymentSuccessComponent implements OnInit {
    
    constructor(private activatedRoute: ActivatedRoute, 
        private router: Router) {}
  
    ngOnInit() {
    }

}